import util from "../../ts/util"

// TODO:区分コード管理.xlsx参考
// T0001	受注配車区分

// T0003	付替区分

/**
 * T0001 受注配車区分
 */
export const 受注配車区分 = {
  通常貨物: "1",
  海上コンテナ: "2",
} as const

// T0002	配車状態区分
export const e配車状態区分 = {
  未配車: "0",
  配車確定: "1",
  乗務員連絡済: "2",
  その他請求: "8",
  キャンセル: "9",
  海コン未配車: "21",
  手配済: "22",
  台切: "23",
  完了: "24",
} as const

export type T配車状態区分名称 = keyof typeof e配車状態区分
export type T配車状態区分値 = typeof e配車状態区分[T配車状態区分名称]

/**
 * T0003 付替区分
 */
export const e付替区分 = {
  自部所: "1",
  他部所: "2",
} as const

export type T付替区分名称 = keyof typeof e付替区分
export type T付替区分値 = typeof e付替区分[T付替区分名称]

// T0004	稼働手当車種掛率区分
export const e稼働手当車種掛率区分 = {
  "12%": "1",
  "13%": "2",
  "14%": "3",
} as const
export type T稼働手当車種掛率区分名称 = keyof typeof e稼働手当車種掛率区分
export type T稼働手当車種掛率区分値 =
  typeof e稼働手当車種掛率区分[T稼働手当車種掛率区分名称]
// T0005	同乗者場所区分

// T0006	請求支払区分

export const e請求支払区分 = {
  車建て: "1",
  品数毎: "2",
  月額固定: "3",
  請求支払なし: "9",
} as const

export type T請求支払区分名称 = keyof typeof e請求支払区分
export type T請求支払区分値 = typeof e請求支払区分[T請求支払区分名称]

/**
 * T0007	課税区分
 */
export const e課税区分 = {
  課税: "1",
  非課税: "2",
} as const

export type T課税区分名称 = keyof typeof e課税区分
export type T課税区分値 = typeof e課税区分[T課税区分名称]

/**
 * T0008	税込区分
 */
export const e税込区分 = {
  税抜: "0",
  税込: "1",
} as const

export type T税込区分名称 = keyof typeof e税込区分
export type T税込区分値 = typeof e税込区分[T税込区分名称]

// T0009	確認区分
export const e請求支払確認区分 = {
  未確認: "0",
  確認済: "1",
} as const
/**
 *  T0010	工程区分
 */
export const e工程区分 = {
  積: "11",
  卸: "12",
  PICK: "21",
  作業: "22",
  返却: "23",
  その他: "24",
} as const

export const e工程区分名称 = util.getReverseEnum(e工程区分)

export type T工程区分名称 = keyof typeof e工程区分
export type T通常貨物工程区分名称 = keyof Omit<
  typeof e工程区分,
  "PICK" | "作業" | "返却" | "その他"
>
export type T海コン工程区分名称 = keyof Omit<typeof e工程区分, "積" | "卸">
export type T工程区分値 = typeof e工程区分[T工程区分名称]

// T0011	海コン付帯作業区分
export const e海コン付帯作業区分 = {
  ダンプアップ: "1",
  休日手当: "2",
  税関検査: "3",
  フォーク作業: "4",
} as const

export type T海コン付帯作業区分 = keyof typeof e海コン付帯作業区分

// T0012	コンテナサイズ
// T0013	コンテナ軸
// T0014	請求支払処理状態区分
export const e請求支払処理状態区分 = {
  未処理: "0",
  処理済: "1",
  確定: "2",
  送付済: "3",
} as const
// T0015	金額区分

/**
 *  T0018	受払区分
 */
export const e受払区分 = {
  受入: "1",
  払出: "2",
} as const

/**
 * T0026 車輌経費区分
 */
export const e車輌経費区分 = {
  償却費: "1",
  任意保険: "2",
} as const
